export default __webpack_public_path__ + "static/media/solta1.4ab28a0a.jpg";